import {Component, computed, inject} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map, startWith} from 'rxjs';
import {SideNav, SideNavItem} from '../../../../components/side-nav/side-nav';
import {RouteUri} from '../../../../constants/route-uri';

type AccountingSection = typeof RouteUri.ACCOUNTING_CODES | typeof RouteUri.ACCOUNTING_PERIODS | typeof RouteUri.ACCOUNTING_TAXES;

@Component({
  selector: 'elcia-accounting-settings',
  imports: [SideNav, RouterOutlet],
  templateUrl: './accounting-settings.html',
  styleUrl: './accounting-settings.scss',
})
export class AccountingSettings {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly navItems: SideNavItem<AccountingSection>[] = [
    {value: RouteUri.ACCOUNTING_CODES, label: 'entity.accounting-accounts'},
    {value: RouteUri.ACCOUNTING_PERIODS, label: 'entity.accounting-periods'},
    {value: RouteUri.ACCOUNTING_TAXES, label: 'entity.taxes'},
  ];

  private routerUrl = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url)
    )
  );

  activeSection = computed<AccountingSection>(() => {
    const url = this.routerUrl() ?? '';
    return this.navItems.find(item => url.includes(item.value))?.value ?? RouteUri.ACCOUNTING_CODES;
  });

  navigate(section: AccountingSection): void {
    this.router.navigate([section], {relativeTo: this.route});
  }
}
